import { useBack } from "./back";
import { t } from "./texts";

export interface SheetAction {
  label: string;
  onClick(): void;
  danger?: boolean;
  primary?: boolean;
  disabled?: boolean;
}

/** A menu of full-width buttons from the bottom of the screen (instead of small context menus). */
export function ActionSheet(props: { title?: string; children?: React.ReactNode; actions: SheetAction[]; onClose(): void }) {
  useBack(props.onClose);
  return (
    <div className="overlay" onClick={props.onClose}>
      <div className="dialog sheet" role="dialog" onClick={(e) => e.stopPropagation()}>
        {props.title && <h2 className="sheet-title">{props.title}</h2>}
        {props.children}
        {props.actions.map((a) => (
          <button key={a.label} className={a.danger ? "danger" : a.primary ? "primary" : "secondary"} disabled={a.disabled}
            onClick={a.onClick}>{a.label}</button>
        ))}
        <button className="ghost" onClick={props.onClose}>{t.cancel}</button>
      </div>
    </div>
  );
}
